/* STEFANO - JS pagine prodotto (product, box, oyma, gift-card, mystery-box) */
(function () {
  /* ---------- Badge sconto accanto al prezzo ---------- */
  var BADGE_ID = 'product-page-discount-badge';
  var BADGE_CLASS =
    'product-badges__badge product-badges__badge--rectangle color-custom-badge-sale';

  function parsePrice(text) {
    var s = String(text || '').replace(/[^\d.,-]/g, '');
    var lastDot = s.lastIndexOf('.');
    var lastComma = s.lastIndexOf(',');

    if (lastDot > -1 && lastComma > -1) {
      s = lastComma > lastDot ? s.replace(/\./g, '').replace(',', '.') : s.replace(/,/g, '');
    } else {
      s = s.replace(/,/g, '.');
    }

    return parseFloat(s);
  }

  function updateDiscountBadge() {
    var container = document.querySelector('[ref="priceContainer"]');
    if (!container) return;

    var compareEl = container.querySelector('.compare-at-price');
    var priceEl = container.querySelector('.price');
    var badge = container.querySelector('#' + BADGE_ID);
    var percent = 0;

    if (compareEl && priceEl) {
      var compare = parsePrice(compareEl.textContent);
      var price = parsePrice(priceEl.textContent);
      if (compare > price) percent = Math.round(((compare - price) / compare) * 100);
    }

    if (!percent) {
      if (badge) badge.remove();
      return;
    }

    var text = '-' + percent + '%';

    if (badge) {
      if (badge.textContent !== text) badge.textContent = text;
      return;
    }

    badge = document.createElement('span');
    badge.id = BADGE_ID;
    badge.className = BADGE_CLASS;
    badge.textContent = text;

    var anchor = priceEl.closest("span[role='group']") || priceEl;
    anchor.insertAdjacentElement('afterend', badge);
  }

  function initDiscountBadge() {
    var container = document.querySelector('[ref="priceContainer"]');
    if (!container) return;

    updateDiscountBadge();

    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(updateDiscountBadge, 120);
    }).observe(container, { childList: true, subtree: true, characterData: true });

    // Il contenitore del prezzo può essere sostituito al cambio di variante
    document.addEventListener('variant:update', function () {
      setTimeout(updateDiscountBadge, 150);
    });
  }

  /* ---------- Miniature del carosello su mobile ---------- */
  var mobileQuery = window.matchMedia('(max-width: 749px)');
  var thumbRetries = 0;

  function selectSlide(slideshow, index) {
    if (typeof slideshow.select === 'function') {
      slideshow.select(index);
      return;
    }

    var dot = slideshow.querySelectorAll('slideshow-controls button[ref="dots[]"]')[index];
    if (dot) dot.click();
  }

  function setActiveThumb(thumbs, index) {
    thumbs.forEach(function (thumb, i) {
      thumb.classList.toggle('active', i === index);
    });

    var active = thumbs[index];
    var strip = active && active.parentElement;
    if (!strip) return;

    var offset = active.getBoundingClientRect().left - strip.getBoundingClientRect().left;

    strip.scrollTo({
      left: strip.scrollLeft + offset - (strip.offsetWidth - active.offsetWidth) / 2,
      behavior: 'smooth',
    });
  }

  function buildThumbnails(slideshow) {
    var slides = Array.prototype.slice.call(slideshow.querySelectorAll('slideshow-slide'));
    if (slides.length <= 1) return;

    var strip = document.createElement('div');
    strip.className = 'custom-thumbnails-mobile';

    var thumbs = [];

    slides.forEach(function (slide, index) {
      var source = slide.querySelector('img.product-media__image');
      if (!source) return;

      var thumb = document.createElement('div');
      thumb.className = 'custom-thumbnail-mobile' + (index === 0 ? ' active' : '');

      var img = document.createElement('img');
      img.src = source.src.replace(/width=\d+/, 'width=400');
      img.alt = source.alt || 'Miniatura ' + (index + 1);
      img.loading = 'lazy';

      thumb.appendChild(img);
      thumb.addEventListener('click', function () {
        selectSlide(slideshow, index);
        setActiveThumb(thumbs, index);
      });

      strip.appendChild(thumb);
      thumbs.push(thumb);
    });

    slideshow.insertAdjacentElement('afterend', strip);

    // Segue il carosello quando cambia slide (swipe o frecce)
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var slide = mutation.target;
        if (slide.getAttribute('aria-hidden') !== 'false') return;

        var index = slides.indexOf(slide);
        if (index > -1) setActiveThumb(thumbs, index);
      });
    });

    slides.forEach(function (slide) {
      observer.observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] });
    });
  }

  function initThumbnails() {
    if (!mobileQuery.matches || document.querySelector('.custom-thumbnails-mobile')) return;

    var slideshow = document.querySelector('slideshow-component');
    if (!slideshow) {
      if (thumbRetries++ < 10) setTimeout(initThumbnails, 500);
      return;
    }

    buildThumbnails(slideshow);
  }

  function init() {
    initDiscountBadge();
    initThumbnails();

    // Galleria ridisegnata (es. cambio di variante): ricrea le miniature se mancano
    new MutationObserver(function (mutations) {
      var added = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          return (
            node.nodeType === 1 &&
            (node.tagName === 'SLIDESHOW-COMPONENT' || node.querySelector('slideshow-component'))
          );
        });
      });

      if (added) setTimeout(initThumbnails, 300);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
